import { render, staticRenderFns } from "./ReservationAllowancesModule.vue?vue&type=template&id=1cb3c4d9&lang=pug"
import script from "./ReservationAllowancesModule.vue?vue&type=script&lang=js"
export * from "./ReservationAllowancesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports